<template>
  <div class="copy-block">
    <span>https://chat.top</span>
    <div class="copy-btn" :data-clipboard-text="`https://chat.xiaoheihe.cn/app/?mini_pro_id=${mini_pro_id}`" @click="copy">复制</div>
  </div>
</template>

<script>
import ClipboardJS from 'clipboard';
export default {
  props: {
    mini_pro_id: {
      type: String,
      default: '',
    },
  },
  methods: {
    copy() {
      var clipboard = new ClipboardJS('.copy-btn');
      clipboard.on('success', () => {
        this.$parent.showToast = true;
        clipboard.destroy();
      });
    },
  },
};
</script>

<style scoped lang="less">
.copy-block {
  height: 50px;
  border-radius: 6px;
  padding: 8px 8px 8px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;

  span {
    color: #000;
    font-family: 'Source Han Sans CN';
    font-size: 16px;
    font-weight: 700;
    line-height: normal;
  }
  &.linear-block {
    background: linear-gradient(90deg, #fff 0%, #ecffd7 100%);
  }
  .copy-btn {
    width: 50px;
    height: 34px;
    background: #2d7d46;
    border-radius: 4px;
    text-align: center;
    line-height: 34px;
    flex-shrink: 0;
    font-weight: 700;
    font-size: 14px;
    color: #ffffff;
  }
}
</style>
